import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Onlinecabbookingnavimumbaiairport() {



const cardData = {
  keyword: " Online Cab Booking Navi Mumbai Airport",

headingDescription:
  "Omshree Cab offers reliable and convenient online cab booking for Navi Mumbai Airport, providing travelers with a seamless way to arrange airport transportation anytime. Whether you need an airport pickup, airport drop, or intercity transfer, our online booking system allows you to reserve your cab quickly with just a few details. Travelers can select their pickup and drop locations, choose their preferred vehicle type, and schedule the ride according to their travel plans. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and corporate groups. With professional chauffeurs, punctual service, and 24/7 availability, Omshree Cab ensures a comfortable and stress-free journey to or from Navi Mumbai International Airport. Online cab booking also provides transparent pricing, instant confirmation, and flexible travel options for local rides as well as long-distance journeys.",

topPlaces: [
  {
    title: "Central Park Kharghar",
    description:
      "Central Park in Kharghar is one of the largest and most scenic urban parks in Navi Mumbai, covering a vast area with gardens, jogging tracks, fountains, and recreational spaces. The park offers beautiful landscapes where visitors can enjoy morning walks, outdoor activities, and family picnics. It also features botanical gardens and open grounds used for cultural events and sports activities. Travelers arriving through Navi Mumbai Airport can easily book an online cab and visit Central Park to relax and enjoy the peaceful greenery after a long journey. The park has become a popular recreational destination for both residents and tourists visiting Navi Mumbai. According to available information, the park spans over a large area and includes walking trails and various leisure facilities for visitors. :contentReference[oaicite:0]{index=0}"
  },
  {
    title: "Pandavkada Waterfalls",
    description:
      "Pandavkada Waterfalls is a popular natural attraction located in the Kharghar area of Navi Mumbai. The waterfall drops from a height of around 107 meters and is surrounded by lush green hills and forests. It becomes especially beautiful during the monsoon season when water flows heavily over the rocky cliff, creating a breathtaking view. Visitors often come here for nature photography, trekking, and short day trips. Travelers booking an online cab from Navi Mumbai Airport can conveniently reach the waterfall and enjoy the peaceful natural environment away from the busy city areas. The waterfall is associated with local legends linked to the Pandavas from the Mahabharata, which adds cultural significance to the site. :contentReference[oaicite:1]{index=1}"
  },
  {
    title: "Palm Beach Road",
    description:
      "Palm Beach Road is one of the most scenic and well-planned roads in Navi Mumbai. Stretching along the coastline, the road offers beautiful views of water bodies, modern residential complexes, and the city skyline. Many visitors enjoy evening drives along this route because of the smooth traffic flow and picturesque surroundings. Travelers using online cab booking from Navi Mumbai Airport can enjoy a comfortable ride along Palm Beach Road while exploring the city’s modern infrastructure and waterfront areas."
  },
  {
    title: "DY Patil Stadium",
    description:
      "DY Patil Stadium is a major sports and entertainment venue located in Navi Mumbai. The stadium hosts international cricket matches, football games, concerts, and large cultural events throughout the year. Known for its modern design and excellent facilities, it attracts sports fans and tourists from across the region. Visitors arriving at Navi Mumbai Airport can easily reach the stadium by booking a cab online and enjoy events or explore the surrounding entertainment areas."
  },
  {
    title: "Seawoods Grand Central Mall",
    description:
      "Seawoods Grand Central Mall is one of the most popular shopping and lifestyle destinations in Navi Mumbai. The mall features international retail brands, restaurants, entertainment zones, and multiplex cinemas. Visitors can spend hours shopping, dining, and enjoying leisure activities. Travelers arriving through Navi Mumbai Airport can conveniently reach the mall using an online cab booking and enjoy a comfortable shopping experience."
  },
  {
    title: "Utsav Chowk",
    description:
      "Utsav Chowk is a well-known landmark located in Kharghar and is famous for its impressive architectural design and beautiful fountains. The surrounding area has cafes, restaurants, and shopping outlets where visitors can spend leisure time. It is a popular location for photography and evening outings. Travelers using an online cab booking from Navi Mumbai Airport can easily include Utsav Chowk as part of their city sightseeing."
  },
  {
    title: "Belapur Fort",
    description:
      "Belapur Fort is a historic structure in Navi Mumbai that reflects the region’s historical past and architectural heritage. The fort once served as an important defense point during earlier periods and today stands as a historical attraction surrounded by greenery. Visitors often explore the old walls and scenic surroundings while learning about the region’s history. Booking a cab online from Navi Mumbai Airport allows travelers to comfortably visit this heritage site."
  },
  {
    title: "Parsik Hill",
    description:
      "Parsik Hill is a scenic hill range located near Navi Mumbai and Thane that offers panoramic views of the surrounding areas. The hill is covered with forested land and features one of the longest railway tunnels in the region. Visitors often come here for nature views, photography, and peaceful drives. Travelers using online cab booking services from Navi Mumbai Airport can enjoy a relaxing trip to this hill area and experience beautiful city viewpoints. :contentReference[oaicite:2]{index=2}"
  },
  {
    title: "Panvel Creek",
    description:
      "Panvel Creek is a coastal water body located near Panvel and Navi Mumbai. Historically, the creek served as an important trade route and has been mentioned in historical records. Today, it forms a scenic natural landscape where visitors can enjoy views of the water and surrounding mangrove ecosystems. Travelers arriving through Navi Mumbai Airport can easily reach this area using an online cab service and explore the natural beauty of the region. :contentReference[oaicite:3]{index=3}"
  },
  {
    title: "Raghuleela Mall Vashi",
    description:
      "Raghuleela Mall in Vashi is a well-known shopping and entertainment center in Navi Mumbai. The mall includes retail outlets, restaurants, and cinema halls where visitors can enjoy shopping and leisure activities. It has been a popular commercial hub for residents and tourists visiting the city. Travelers arriving at Navi Mumbai Airport can book a cab online to reach the mall conveniently and enjoy a relaxing shopping experience before continuing their journey. :contentReference[oaicite:4]{index=4}"
  }
],



services: [
{
name: "Online Cab Booking Navi Mumbai Airport",
description: "Online cab booking Navi Mumbai Airport service allows travelers to reserve airport taxis quickly and conveniently from anywhere. Our digital booking system enables passengers to schedule airport pickups and drops with instant confirmation. The service supports multiple vehicle options including sedans, SUVs, and MPVs suitable for airport travel. Professional drivers ensure punctual arrival at the airport terminal and smooth transportation to your destination. Booking can be done through mobile devices or websites for easy travel planning. Ideal for business travelers, tourists, and family airport transfers. Transparent pricing and reliable service ensure stress-free airport travel."
},
{
name: "Navi Mumbai Airport Online Taxi Booking",
description: "Navi Mumbai Airport online taxi booking provides a simple and efficient way to reserve taxis for airport transfers. Passengers can easily book rides online and receive quick confirmation within minutes. Vehicles are clean, air-conditioned, and suitable for comfortable airport transportation. Professional drivers ensure timely pickup from homes, hotels, offices, and airport terminals. Online booking eliminates waiting time and guarantees vehicle availability. Ideal for travelers planning advance airport travel. Convenient scheduling options make the service reliable and efficient."
},
{
name: "Book Cab Navi Mumbai Airport Online",
description: "Book cab Navi Mumbai Airport online service enables passengers to reserve vehicles in advance for convenient airport transfers. The online system allows quick booking through mobile or desktop platforms. Vehicles provide comfortable seating and adequate luggage space for travelers. Professional drivers ensure punctual pickup and safe travel across Mumbai and Navi Mumbai. Instant booking confirmation ensures reliable travel planning. Ideal for airport pickups, departures, and corporate travel."
},
{
name: "Airport Taxi Booking Navi Mumbai",
description: "Airport taxi booking Navi Mumbai service provides dependable reservations for passengers traveling to or from Navi Mumbai International Airport. Vehicles offer smooth ride quality and comfortable seating suitable for airport journeys. Professional drivers ensure timely pickups and safe transportation across the city. Booking options include online reservations and quick confirmations. Ideal for tourists, corporate travelers, and families requiring airport transport."
},
{
name: "Navi Mumbai Airport Cab Booking Website",
description: "Navi Mumbai Airport cab booking website allows passengers to easily reserve vehicles for airport transfers using a simple online platform. Travelers can choose their preferred vehicle type depending on group size and luggage requirements. The booking process is quick and secure with instant ride confirmation. Professional drivers ensure punctual pickups from homes, offices, hotels, and airport terminals. Ideal for travelers planning convenient airport transportation."
},
{
name: "Instant Airport Cab Booking Navi Mumbai",
description: "Instant airport cab booking Navi Mumbai service provides quick taxi reservations for travelers who need urgent airport transportation. The booking platform allows immediate vehicle allocation with rapid confirmation. Vehicles provide comfortable seating and smooth ride quality suitable for airport journeys. Professional drivers ensure fast pickups and safe travel across Mumbai and Navi Mumbai."
},
{
name: "Cheap Airport Taxi Booking Navi Mumbai",
description: "Cheap airport taxi booking Navi Mumbai service offers budget-friendly airport transportation without compromising safety or comfort. Travelers can enjoy clean vehicles and professional drivers at economical fares. The service provides reliable airport pickups and drops across the city. Transparent pricing ensures no hidden charges. Ideal for students, tourists, and budget travelers."
},
{
name: "Best Airport Cab Booking Navi Mumbai",
description: "Best airport cab booking Navi Mumbai service provides premium and reliable airport transportation for passengers seeking professional travel service. Vehicles provide spacious seating and comfortable interiors suitable for airport journeys. Professional drivers ensure punctual pickups and smooth driving across the city. Ideal for corporate travelers, families, and tourists."
},
{
name: "Airport Pickup Taxi Booking Navi Mumbai",
description: "Airport pickup taxi booking Navi Mumbai service provides reliable transportation for passengers arriving at the airport. Drivers track flight schedules to ensure timely pickup even in case of delays. Vehicles offer comfortable seating and luggage capacity suitable for travelers. Pickup services are available for hotels, homes, and offices across Mumbai and Navi Mumbai."
},
{
name: "Airport Drop Cab Booking Navi Mumbai",
description: "Airport drop cab booking Navi Mumbai service provides timely transportation for passengers traveling to the airport for departures. Professional drivers ensure punctual pickups so travelers reach the airport well before flight time. Vehicles offer comfortable seating and air-conditioned interiors for smooth travel."
},
{
name: "Navi Mumbai Airport Cab Booking App",
description: "Navi Mumbai Airport cab booking app allows passengers to reserve taxis instantly through mobile applications. The app provides easy booking, ride tracking, and instant confirmation for airport transfers. Travelers can select vehicles according to their comfort and travel needs. Professional drivers ensure safe and punctual travel."
},
{
name: "24x7 Airport Cab Booking Navi Mumbai",
description: "24x7 airport cab booking Navi Mumbai service provides round-the-clock transportation for passengers traveling at any time of the day or night. Whether early morning departures or late-night arrivals, drivers are available to provide reliable airport transfers. Vehicles are clean, comfortable, and suitable for airport travel."
},
{
name: "Online Taxi Reservation Navi Mumbai Airport",
description: "Online taxi reservation Navi Mumbai Airport service allows passengers to pre-book taxis for convenient airport transfers. The reservation system ensures guaranteed vehicle availability and timely pickup services. Vehicles provide comfortable seating and smooth ride performance suitable for airport journeys."
},
{
name: "Innova Airport Cab Booking Navi Mumbai",
description: "Innova airport cab booking Navi Mumbai service provides spacious MPV transportation ideal for families and groups traveling with luggage. Toyota Innova vehicles offer comfortable seating and smooth ride quality suitable for airport journeys. Professional drivers ensure punctual pickups and safe driving."
}
],

tableData: [
["Online Cab Booking Navi Mumbai Airport","Navi Mumbai Airport Online Taxi Booking"],
["Book Cab Navi Mumbai Airport Online","Airport Taxi Booking Navi Mumbai"],
["Navi Mumbai Airport Cab Booking Website","Instant Airport Cab Booking Navi Mumbai"],
["Cheap Airport Taxi Booking Navi Mumbai","Best Airport Cab Booking Navi Mumbai"],
["Airport Pickup Taxi Booking Navi Mumbai","Airport Drop Cab Booking Navi Mumbai"],
["Navi Mumbai Airport Cab Booking App","24x7 Airport Cab Booking Navi Mumbai"],
["Online Taxi Reservation Navi Mumbai Airport","Innova Airport Cab Booking Navi Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Easy Online Cab Booking",
    WhyChoosedescription: "Omshree Cabs provides a simple and quick online cab booking system for Navi Mumbai Airport transfers. Customers can book their airport cab within minutes and receive instant confirmation."
  },
  {
    WhyChooseheading: "Transparent Airport Cab Pricing",
    WhyChoosedescription: "We provide transparent pricing for online cab booking to and from Navi Mumbai Airport. Customers receive clear fare details including toll charges and travel costs before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our online cab booking service for Navi Mumbai Airport is available 24 hours a day. Whether your flight arrives early morning or late at night, our cabs are available anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, fully air-conditioned, and regularly cleaned to ensure passengers enjoy a comfortable airport transfer experience."
  },
  {
    WhyChooseheading: "Flexible Airport Travel Options",
    WhyChoosedescription: "We offer flexible airport transportation options including airport pickup, airport drop, round-trip airport travel, and outstation transfers directly from Navi Mumbai Airport."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai & Navi Mumbai",
    WhyChoosedescription: "Our airport cab service offers doorstep pickup from homes, offices, hotels, railway stations, and business locations across Mumbai and Navi Mumbai."
  },
  {
    WhyChooseheading: "Reliable Airport Transfer Service",
    WhyChoosedescription: "Omshree Cabs is trusted by travelers for reliable online cab booking to Navi Mumbai Airport thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Can I book a cab online for Navi Mumbai Airport?", answer: "Yes, Omshree Cabs provides an easy online cab booking system for Navi Mumbai Airport pickup and drop services." },
  { question: "Is online cab booking available 24 hours?", answer: "Yes, our online cab booking service operates 24/7 for all airport travel requirements." },
  { question: "Which vehicles are available for airport travel?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on passenger requirements." },
  { question: "Can I book airport pickup online?", answer: "Yes, passengers can book airport pickup services online where the driver will wait at the arrival terminal." },
  { question: "Do you provide airport drop services from Mumbai city?", answer: "Yes, we provide airport drop services from all areas of Mumbai including Western Suburbs, Central Suburbs, and South Mumbai." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable airport travel." },
  { question: "Do drivers track flight arrival times?", answer: "Yes, our drivers track flight arrival times to ensure timely pickup even if flights are delayed." },
  { question: "Is advance online booking recommended?", answer: "Yes, advance online booking is recommended especially during peak travel hours." },
  { question: "Do you provide airport transfers for corporate travelers?", answer: "Yes, we provide airport transportation services for corporate travelers and business executives." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Mehta",
    feedback:
      "Booked an airport cab online with Omshree Cabs. The booking process was simple and the driver arrived on time.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Shah",
    feedback:
      "Very convenient online cab booking service for Navi Mumbai Airport. Clean car and smooth journey.",
    rating: 5
  }
];









































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Online Cab Booking Navi Mumbai Airport",
  "description": "Omshree Cab provides instant online cab booking for Navi Mumbai Airport. Reserve your Innova, Ertiga, or sedan cab for airport pickup or drop, available 24/7 for safe and comfortable travel.",
  "provider": {
    "@type": "Organization",
    "name": "Omshree Cab",
    "telephone": "+91 9892544084",
    "url": "https://www.omshreecab.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai"
  },
  "serviceType": "Airport Cab Booking Service"
};






  return (
    <div>
      <Helmet>
  <title>Online Cab Booking Navi Mumbai Airport | Omshree Cab 24x7 Service</title>
  <meta 
    name="description" 
    content="Book your cab online at Navi Mumbai Airport with Omshree Cab. Instant taxi booking in Innova, Ertiga, or sedan for pickup & drop. Available 24/7 for reliable airport travel." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/85.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onlinecabbookingnavimumbaiairport;